import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-talk-button',
  templateUrl: './talk-button.component.html',
  styleUrls: ['./talk-button.component.scss']
})
export class TalkButtonComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
